module.exports = __webpack_public_path__ + "static/chimera-871822c308d723ed32aca5b6aa40ecc6.jpeg";